module.exports = __webpack_public_path__ + "img/cover.cfe3c28d.jpg";